<div
  id="ticket-details"
  class="md:flex md:flex-col md:justify-between bg-white shadow-[0px_3px_6px_0px_rgba(0,0,0,0.16)] p-4 border border-[#F2F2F2] rounded-3xl w-full h-fit">
  <div>
    <div class="flex items-center px-2 md:px-8 pt-2">
      <div class="w-full md:text-left text-center">
        @if (variant() === 'summary') {
          <h3 class="mb-1 font-extrabold text-main-blue text-xl">
            Tickets Details
          </h3>
        } @else {
          <h3 class="mb-1 font-extrabold text-main-blue text-xl">
            Your Ticket Details
          </h3>
          <p class="font-semibold text-gray-400">
            {{ transaction().transaction.event?.description }} -
            @if (showDateAsTbd) {
              {{ eventDateTbdText }}
            } @else {
              {{ transaction().transaction.event?.date | date: 'short' }}
            }
          </p>
        }
      </div>
    </div>
    <div class="px-2 md:px-4">
      <div class="w-full">
        <table class="w-full border-separate table-fixed">
          @for (section of seatsForTable(); track section.id) {
            <tr class="flex flex-wrap md:flex-nowrap my-2 mb-3 md:mb-0">
              <td class="content-center mb-1 md:mb-0 w-full md:w-16 td">
                <div class="flex justify-center items-center">
                  <img
                    ngSrc="/assets/img/chair-blue-icon.svg"
                    alt="main chair icon"
                    width="12"
                    height="12"
                    [priority]="false"
                    class="mr-1" />
                  <p class="font-bold text-main-blue text-center">
                    {{ section.totalSectionSeats }}
                  </p>
                </div>
              </td>
              <td
                class="flex justify-center md:mx-2 mb-1 md:mb-0 w-full md:w-48 md:shrink-0 td">
                <p class="flex items-center text-center">
                  Section
                  <span class="ml-2 font-bold text-main-blue">{{
                    section.id
                  }}</span>
                </p>
              </td>
              <td class="p-0 w-full">
                @for (row of section.rows; track row.id) {
                  <div
                    class="flex flex-wrap md:flex-nowrap gap-2 mb-1 last:mb-0">
                    <p class="flex items-center td-row">
                      Row<span class="ml-2 font-bold text-main-blue">{{
                        row.id
                      }}</span>
                    </p>
                    <p class="flex flex-1 items-center td-seats">
                      {{ seatsLabel(row.seatsNumbers.length)
                      }}<span class="ml-2 font-bold text-main-blue">{{
                        row.seatsNumbers.join(', ')
                      }}</span>
                    </p>
                  </div>
                }
              </td>
            </tr>
          }
        </table>
      </div>
      <div
        class="px-2 md:px-4 mt-4"
        [class.md:flex]="variant() === 'summary'"
        [class.md:items-center]="variant() === 'summary'"
        [class.md:justify-between]="variant() === 'summary'"
        [class.border-t]="variant() === 'summary'"
        [class.border-[#f0f0f0]]="variant() === 'summary'"
        [class.pt-4]="variant() === 'summary'">
        <div>
          @for (seat of seatsByPrice(); track $index) {
            <h4 class="font-bold md:text-left text-center">
              <span data-cy="cart-seats-quantity" class="text-main-blue">{{
                seat.quantity
              }}</span>
              Seats x
              <span data-cy="cart-buyer-type">{{
                transaction().transaction.buyerTypeName
              }}</span>
              at
              <span class="text-main-blue"
                >${{ seat.price | number: '1.2-2' }}</span
              >
            </h4>
          }
        </div>
        @if (
          variant() === 'summary' &&
          transaction().transaction.tdcTransaction?.totalPriceSeats
        ) {
          <h5
            data-cy="cart-ticket-total"
            class="flex items-baseline gap-1 mt-2 md:mt-0 font-bold">
            <span class="text-xs">Ticket Total:</span>
            <span class="text-main-blue text-base">
              ${{
                transaction().transaction.tdcTransaction?.totalPriceSeats
                  | number: '1.2-2'
              }}
            </span>
          </h5>
        }
      </div>
    </div>
  </div>
  @if (variant() === 'checkout') {
    <div class="flex justify-end items-center p-5 border-t border-t-gray-100">
      @if (transaction().transaction.tdcTransaction?.totalPriceSeats) {
        <h5 class="flex items-baseline gap-1 font-bold">
          <span class="text-xs">Total Price:</span>
          <span class="text-main text-base">
            ${{
              transaction().transaction.tdcTransaction?.totalPriceSeats
                | number: '1.2-2'
            }}
          </span>
        </h5>
      }
    </div>
  }
</div>
